module.exports = __webpack_public_path__ + "assets/img/authority-4.8baf78e1.svg";